var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: "fade", duration: { leave: 800, enter: 800 } } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.closed,
              expression: "!closed"
            }
          ],
          staticClass: "swap-item-container"
        },
        [
          _vm.shouldLoadImg
            ? _c(
                "div",
                {
                  ref: "slideImageContainer",
                  staticStyle: {
                    height: "calc(100% - 20px)",
                    margin: "15px auto"
                  }
                },
                [
                  _c("spinner", { attrs: { show: !_vm.imgLoading.isLoaded } }),
                  _vm._v(" "),
                  _c("img", {
                    directives: [
                      {
                        name: "images-loaded",
                        rawName: "v-images-loaded",
                        value: _vm.imgLoaded,
                        expression: "imgLoaded"
                      }
                    ],
                    ref: "slideImage",
                    class: {
                      "slideshow-zoom__image--hide": !_vm.imgLoading.isLoaded,
                      "slideshow-zoom__image": true
                    },
                    staticStyle: { left: "0" },
                    attrs: {
                      src: _vm.product
                        ? _vm.apiImageUrl(_vm.images[_vm.index])
                        : _vm.imageUrl(_vm.images[_vm.index])
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("img", {
            staticClass: "close-modal",
            staticStyle: { top: "calc(100% - 60px)" },
            attrs: { src: _vm.imageUrl("close-modal.png") },
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.closeModal.apply(null, arguments)
              }
            }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-371aafd6", { render: render, staticRenderFns: staticRenderFns })
  }
}